import React, { useEffect } from 'react'
import { navigate } from 'gatsby'

export const RedirectWithStatusCode = ({
  toPath,
  statusCode = 301,
}) => {
  useEffect(() => {
    navigate(toPath, { replace: true, state: { statusCode } })
  }, [toPath, statusCode])

  return null
}
